package meineglasfaser.api

import kotlinx.serialization.Serializable
import kotlin.time.Instant

interface Entity {
    val id: String
    val createdAt: Instant
    val createdBy: String
    val updatedAt: Instant
    val updatedBy: String
}

@Serializable
data class EntityMeta(
    val createdAt: Instant,
    val createdBy: String,
    val updatedAt: Instant,
    val updatedBy: String,
)
